import { render } from "./CookieSetting.vue?vue&type=template&id=44334356"
import script from "./CookieSetting.vue?vue&type=script&lang=js"
export * from "./CookieSetting.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__